export default {
  headline: {
    id: 'rm_intro_modal_headline',
    defaultMessage: 'Mine My Phone',
  },
  step1Subtitle: {
    id: 'rm_intro_modal_step_1_subtitle',
    defaultMessage: 'Do you know how heavy your phone really is?',
  },
  step1Body: {
    id: 'rm_intro_modal_step_1_body',
    defaultMessage:
      'A new phone can require up to 1,000 times its own weight in raw material extraction, leaving behind scarred landscapes, stolen childhoods, and international conflict.',
  },
  // The clip step's statement — it is the old step 3 with a looping video in place of the
  // still, so it keeps that step's id and its position.
  step3Body: {
    id: 'rm_intro_modal_step_3_body',
    defaultMessage:
      'Trace the metals found in your phone back to their origins through their environmental, human, and geopolitical impacts.',
  },
  // The closing step: a question over the three impact cards, which are the only way into
  // the campaign from here (skipping is the other exit, and lands on the bare home).
  lastTitle: {
    id: 'rm_intro_modal_last_title',
    defaultMessage: 'Ready to start mining?',
  },
  lastBody: {
    id: 'rm_intro_modal_last_body',
    defaultMessage:
      'Choose one of the 3 major impacts of raw material extraction to start.',
  },
  ctaStart: {
    id: 'rm_intro_modal_cta_start',
    defaultMessage: 'Start Mining',
  },
  ctaNext: { id: 'rm_intro_modal_cta_next', defaultMessage: 'Next' },
  back: { id: 'rm_intro_modal_back', defaultMessage: 'Back' },
  // Now the ✕'s accessible name: the control looks like a close button but what it does
  // is skip the onboarding, which is the more useful thing to announce.
  skip: { id: 'rm_intro_modal_skip', defaultMessage: 'Skip' },
  // Visual indicator (zero-padded by the caller); `stepProgress` is the
  // screen-reader sentence for the same thing.
  stepCounter: {
    id: 'rm_intro_modal_step_counter',
    defaultMessage: '{current} / {total}',
  },
  stepProgress: {
    id: 'rm_intro_modal_step_progress',
    defaultMessage: 'Step {current} of {total}',
  },
} as const
